<style src="./Bubble.scss" lang="scss"></style>

<script>
	import Icon from '@/components/Icon/Icon';

	export default {
		name: 'HpBubble',
		components: {
			'hp-icon': Icon
		},
		props: {
			href: String,
			imageUrl: String,
			iconUrl: String,
			text: String,
			textColor: String,
			backgroundColor: String
		},
		data () {
			return {
				isVisible: true
			};
		},
		computed: {
			style () {
				let inlineStyle = this.textColor ? `color:${this.textColor};` : '';
				inlineStyle += this.backgroundColor ? `background:${this.backgroundColor};` : '';

				return inlineStyle || false;
			}
		},
		methods: {
			close () {
				this.isVisible = false;
			}
		}
	};
</script>

<template>
	<div v-if="isVisible" data-component="bubble" :style="style">
		<a v-if="href" :href="href"></a>
		<img v-if="imageUrl" :src="imageUrl" alt="" />
		<div v-else data-text>
			<img v-if="iconUrl" :src="iconUrl" data-icon alt="icon" />
			<span>{{ text }}</span>
		</div>
		<hp-icon data-close-button type="close" @click="close"></hp-icon>
	</div>
</template>
